import React, { useEffect, useState } from "react";
import { useTheme } from "next-themes";
import { Sun, Moon } from "lucide-react";
import { cn } from "../../lib/utils";

/**
 * Light/dark switch. Theme flips the whole portal via CSS-variable aliasing
 * (see scripts/gen-theme.js + index.css). next-themes persists to localStorage
 * ("so-theme") and toggles the `light`/`dark` class on <html>.
 */
const ThemeToggle = ({ className }) => {
  const { resolvedTheme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  // next-themes can't know the theme until mounted (no SSR here, but this
  // avoids a hydration/first-paint mismatch on the icon).
  useEffect(() => setMounted(true), []);

  const isLight = mounted && resolvedTheme === "light";

  return (
    <button
      type="button"
      onClick={() => setTheme(isLight ? "dark" : "light")}
      title={isLight ? "Switch to dark theme" : "Switch to light theme"}
      data-testid="theme-toggle"
      className={cn(
        "flex items-center justify-center p-2 rounded-md shrink-0",
        "text-zinc-400 hover:text-zinc-50 hover:bg-zinc-800/50 transition-colors",
        className,
      )}
    >
      {isLight ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />}
    </button>
  );
};

export default ThemeToggle;
